// Shared site scripts, loaded on every page.

// Scroll-reveal: any element with class "reveal" fades in when scrolled into view.
// Also handles the theme editor: when a section is re-rendered on edit, its fresh
// .reveal elements must be re-observed (otherwise they stay invisible = "section broke").
// In design mode we reveal immediately so editing never hides content.
(function () {
  var design = window.Shopify && Shopify.designMode;
  function revealAll(root) {
    (root || document).querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.14 });
  function observe(root) {
    (root || document).querySelectorAll('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }
  if (design) { revealAll(); } else { observe(); }
  document.addEventListener('shopify:section:load', function (e) {
    if (design) { revealAll(e.target); } else { observe(e.target); }
  });
})();

// Coffee scroll peek (homepage): leans in while the Subscribe section is in view.
(function () {
  var peek = document.getElementById('coffeePeek');
  var trigger = document.getElementById('subscribe');
  if (!peek || !trigger) return;
  var io = new IntersectionObserver(function (entries) {
    if (peek.classList.contains('dismissed')) return;
    peek.classList.toggle('in', entries[0].isIntersecting);
  }, { threshold: 0.3 });
  io.observe(trigger);
  var close = peek.querySelector('.cp-close');
  if (close) close.addEventListener('click', function (e) {
    e.preventDefault();
    peek.classList.remove('in');
    peek.classList.add('dismissed');
  });
})();

// Subscription pricing option toggle + generic .size-chip toggle.
// Delegated on document so they keep working after the theme editor re-renders a section.
// (.size-chip inside a product form is skipped — the product page manages its own.)
document.addEventListener('click', function (e) {
  var o = e.target.closest && e.target.closest('.opt');
  if (o) {
    o.parentElement.querySelectorAll('.opt').forEach(function (x) { x.classList.remove('selected'); });
    o.classList.add('selected');
  }
  var c = e.target.closest && e.target.closest('.size-chip');
  if (c && !c.closest('form')) {
    c.parentElement.querySelectorAll('.size-chip').forEach(function (x) { x.classList.remove('active'); });
    c.classList.add('active');
  }
});
